module.exports = __webpack_public_path__ + "img/ic_topic_trends.03b20f75.svg";